export default class CustomError extends Error { }
